// import * as types from '@store/mutation-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  typeOptions: [
    {
      label: '理货',
      value: 0,
      points: 30,
    },
    {
      label: '招聘',
      value: 1,
      points: 0,
    },
    {
      label: '促销',
      value: 2,
      points: 0,
    },
    {
      label: '派发',
      value: 3,
      points: 0,
    },
    {
      label: '市调',
      value: 4,
      points: 20,
    },
    {
      label: '数据',
      value: 5,
      points: 35,
    },
    {
      label: '悬赏',
      value: 6,
      points: 50,
    },
    {
      label: '审核',
      value: 7,
      points: 0,
    },
    {
      label: '录入',
      value: 8,
      points: 0,
    },
    {
      label: '其他',
      value: 10,
      points: 30,
    },
    {
      label: '扫码',
      value: 14,
      points: 0,
    },
    {
      label: '活动',
      value: 15,
      points: 0,
    },
    {
      label: '考试',
      value: 16,
      points: 0,
    },
  ],
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const clbTaskTemplate = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/clb-task-template/clb-task-template.store.js